var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "event-card full-width q-pb-md" },
    [
      _c(
        "q-tabs",
        {
          staticClass: "full-width",
          model: {
            value: _vm.event_tab,
            callback: function($$v) {
              _vm.event_tab = $$v
            },
            expression: "event_tab"
          }
        },
        [
          _vm._l(_vm.event_dates, function(event, index) {
            return _c("q-tab", {
              key: "t" + index,
              attrs: {
                slot: "title",
                name: "" + index,
                label: _vm.fDate(event.hr_start)
              },
              slot: "title"
            })
          }),
          _vm._l(_vm.event_dates, function(event, index) {
            return _c(
              "q-tab-pane",
              { key: "tp" + index, attrs: { name: "" + index } },
              [
                _c(
                  "div",
                  { staticClass: "row gutter-xs" },
                  [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("q-select", {
                          attrs: {
                            options: _vm.event_date_types.map(function(e) {
                              return { label: _vm.$t(e.slug), value: e.value }
                            }),
                            error: _vm.$v.event_date_type.$error,
                            disable:
                              event.id !== 0 ||
                              _vm.disableEvents ||
                              !_vm.permissions.presential_edit_events,
                            "float-label": _vm.$t("presential_event_type")
                          },
                          on: { input: _vm.$v.event_date_type.$touch },
                          model: {
                            value: event.event_date_type,
                            callback: function($$v) {
                              _vm.$set(event, "event_date_type", $$v)
                            },
                            expression: "event.event_date_type"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-6 gutter" },
                      [
                        _c("q-datetime", {
                          attrs: {
                            "float-label": _vm.$t("event_start"),
                            type: "datetime",
                            format: "DD/MM/YYYY HH:mm",
                            clearable: "",
                            error: _vm.$v.hr_start.$error,
                            disable:
                              _vm.disableEvents ||
                              !_vm.permissions.presential_edit_events
                          },
                          on: { input: _vm.$v.hr_start.$touch },
                          model: {
                            value: event.hr_start,
                            callback: function($$v) {
                              _vm.$set(event, "hr_start", $$v)
                            },
                            expression: "event.hr_start"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-6 gutter" },
                      [
                        _c("q-datetime", {
                          attrs: {
                            "float-label": _vm.$t("event_end"),
                            type: "datetime",
                            format: "DD/MM/YYYY HH:mm",
                            clearable: "",
                            error: _vm.$v.hr_end.$error,
                            disable:
                              _vm.disableEvents ||
                              !_vm.permissions.presential_edit_events
                          },
                          on: { input: _vm.$v.hr_end.$touch },
                          model: {
                            value: event.hr_end,
                            callback: function($$v) {
                              _vm.$set(event, "hr_end", $$v)
                            },
                            expression: "event.hr_end"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("q-select", {
                          attrs: {
                            options: _vm.event_test_types,
                            error: _vm.$v.has_test.$error,
                            "float-label": _vm.$t("will_have_tests"),
                            disable:
                              event.id !== 0 ||
                              _vm.disableEvents ||
                              !_vm.permissions.presential_edit_events
                          },
                          on: { input: _vm.$v.has_test.$touch },
                          model: {
                            value: event.has_test,
                            callback: function($$v) {
                              _vm.$set(event, "has_test", $$v)
                            },
                            expression: "event.has_test"
                          }
                        })
                      ],
                      1
                    ),
                    event.has_test === 2
                      ? _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-6" },
                          [
                            _c("q-input", {
                              attrs: {
                                type: "number",
                                error: _vm.$v.qty_questions.$error,
                                "float-label": _vm.$t("quantity_questions"),
                                disable:
                                  _vm.disableEvents ||
                                  !_vm.permissions.presential_edit_events
                              },
                              on: { input: _vm.$v.qty_questions.$touch },
                              model: {
                                value: event.qty_questions,
                                callback: function($$v) {
                                  _vm.$set(event, "qty_questions", $$v)
                                },
                                expression: "event.qty_questions"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    event.has_test === 2
                      ? _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-6" },
                          [
                            _c("q-input", {
                              attrs: {
                                type: "number",
                                error: _vm.$v.minimum_score_approval.$error,
                                "float-label": _vm.$t("minimum_score"),
                                disable:
                                  _vm.disableEvents ||
                                  !_vm.permissions.presential_edit_events
                              },
                              on: {
                                input: _vm.$v.minimum_score_approval.$touch
                              },
                              model: {
                                value: event.minimum_score_approval,
                                callback: function($$v) {
                                  _vm.$set(event, "minimum_score_approval", $$v)
                                },
                                expression: "event.minimum_score_approval"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    event.event_date_type === 2 && event.id !== 0
                      ? _c(
                          "div",
                          { staticClass: "q-mt-md row full-width" },
                          [
                            event.webcast.id
                              ? _c(
                                  "q-card",
                                  {
                                    staticClass:
                                      "action-card q-my-sm q-px-sm q-py-md row"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "col-12 items-center" },
                                      [
                                        _c("q-btn", {
                                          staticClass: "self-center card-btn",
                                          attrs: {
                                            color: "secondary",
                                            label: _vm.$t("go_to_webcast"),
                                            icon: "fas fa-broadcast-tower"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.show_webcast_modal = true
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              { staticClass: "col-xs-12 col-sm-12 q-mb-xs" },
                              [
                                _c(
                                  "q-field",
                                  {
                                    attrs: {
                                      count: 256,
                                      helper: _vm.$t(
                                        "leave_it_blank_to_use_the_training_title"
                                      )
                                    }
                                  },
                                  [
                                    _c("q-input", {
                                      ref: "title",
                                      refInFor: true,
                                      attrs: { "float-label": _vm.$t("title") },
                                      model: {
                                        value: event.webcast.title,
                                        callback: function($$v) {
                                          _vm.$set(event.webcast, "title", $$v)
                                        },
                                        expression: "event.webcast.title"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col-xs-12 col-sm-12" },
                              [
                                _vm.canSetProvider(event.webcast)
                                  ? _c("q-select", {
                                      attrs: {
                                        options: _vm.getWebcastTypes(),
                                        "float-label": _vm.$t("stream_type"),
                                        error: !event.webcast.webcast_type
                                          ? true
                                          : false,
                                        chips: "",
                                        "autofocus-filter": "",
                                        disable:
                                          _vm.disableEvents ||
                                          !_vm.permissions
                                            .presential_edit_events
                                      },
                                      model: {
                                        value: event.webcast.webcast_type,
                                        callback: function($$v) {
                                          _vm.$set(
                                            event.webcast,
                                            "webcast_type",
                                            $$v
                                          )
                                        },
                                        expression: "event.webcast.webcast_type"
                                      }
                                    })
                                  : _c("q-select", {
                                      attrs: {
                                        disable: "",
                                        readonly: "",
                                        filled: "",
                                        hint: "Disable and readonly",
                                        options: _vm.getWebcastTypes(),
                                        "float-label": _vm.$t("stream_type"),
                                        chips: "",
                                        "autofocus-filter": ""
                                      },
                                      model: {
                                        value: event.webcast.webcast_type,
                                        callback: function($$v) {
                                          _vm.$set(
                                            event.webcast,
                                            "webcast_type",
                                            $$v
                                          )
                                        },
                                        expression: "event.webcast.webcast_type"
                                      }
                                    })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col-xs-12 col-sm-12" },
                              [
                                event.webcast.webcast_type === 1 ||
                                event.webcast.webcast_type === 3
                                  ? _c("q-input", {
                                      attrs: {
                                        error:
                                          _vm.$v.event_dates.$each[index].embed
                                            .$error,
                                        "float-label": _vm.$t(
                                          "transmission_url"
                                        ),
                                        disable:
                                          _vm.disableEvents ||
                                          !_vm.permissions
                                            .presential_edit_events
                                      },
                                      model: {
                                        value: event.webcast.embed,
                                        callback: function($$v) {
                                          _vm.$set(event.webcast, "embed", $$v)
                                        },
                                        expression: "event.webcast.embed"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm.selected_client_params.webcast_use_score
                              ? _c(
                                  "div",
                                  { staticClass: "col-xs-12 col-sm-12" },
                                  [
                                    !_vm.selected_client_params
                                      .webcast_use_static_score &&
                                    _vm.canSetScore
                                      ? _c("q-input", {
                                          attrs: {
                                            "float-label": _vm.$t("score"),
                                            type: "number",
                                            disable:
                                              _vm.disableEvents ||
                                              !_vm.permissions
                                                .presential_edit_events
                                          },
                                          model: {
                                            value: event.webcast.score,
                                            callback: function($$v) {
                                              _vm.$set(
                                                event.webcast,
                                                "score",
                                                $$v
                                              )
                                            },
                                            expression: "event.webcast.score"
                                          }
                                        })
                                      : _vm._e(),
                                    _vm.selected_client_params
                                      .webcast_use_static_score &&
                                    _vm.canSetScore
                                      ? _c("q-select", {
                                          attrs: {
                                            options: _vm.scores,
                                            "float-label": _vm.$t("score"),
                                            disable:
                                              _vm.disableEvents ||
                                              !_vm.permissions
                                                .presential_edit_events
                                          },
                                          model: {
                                            value: event.webcast.score,
                                            callback: function($$v) {
                                              _vm.$set(
                                                event.webcast,
                                                "score",
                                                $$v
                                              )
                                            },
                                            expression: "event.webcast.score"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              { staticClass: "q-mt-md col-xs-12 col-sm-6" },
                              [
                                _c("p", { staticClass: "caption" }, [
                                  _vm._v(_vm._s(_vm.$t("use_chat")))
                                ]),
                                _c("q-btn-toggle", {
                                  attrs: {
                                    "toggle-color": _vm.getColorUseChat(
                                      event.webcast
                                    ),
                                    options: _vm.chat_options,
                                    disable:
                                      _vm.disableEvents ||
                                      !_vm.permissions.presential_edit_events
                                  },
                                  model: {
                                    value: event.webcast.use_chat,
                                    callback: function($$v) {
                                      _vm.$set(event.webcast, "use_chat", $$v)
                                    },
                                    expression: "event.webcast.use_chat"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "q-mt-md col-xs-12 col-sm-6" },
                              [
                                _c("p", { staticClass: "caption" }, [
                                  _vm._v(_vm._s(_vm.$t("chat_moderated")))
                                ]),
                                _c("q-btn-toggle", {
                                  attrs: {
                                    "toggle-color": _vm.getColorChatModerated(
                                      event.webcast
                                    ),
                                    options: _vm.chat_options,
                                    disable:
                                      _vm.disableChatModerated(event.webcast) ||
                                      _vm.disableEvents ||
                                      !_vm.permissions.presential_edit_events
                                  },
                                  model: {
                                    value: event.webcast.chat_moderated,
                                    callback: function($$v) {
                                      _vm.$set(
                                        event.webcast,
                                        "chat_moderated",
                                        $$v
                                      )
                                    },
                                    expression: "event.webcast.chat_moderated"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "row gutter-sm q-mt-sm" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "col-xs-12 col-sm-12" },
                                  [
                                    _c(
                                      "p",
                                      { staticClass: "caption" },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t" +
                                            _vm._s(_vm.$t("status")) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        ),
                                        _c(
                                          "q-icon",
                                          {
                                            staticClass: "q-ml-sm q-pt-md",
                                            staticStyle: {
                                              "vertical-align": "bottom"
                                            },
                                            attrs: {
                                              name: "far fa-question-circle",
                                              size: "1.5rem",
                                              color: "grey"
                                            }
                                          },
                                          [
                                            _c(
                                              "q-tooltip",
                                              {
                                                staticClass: "custom-tooltip",
                                                attrs: {
                                                  anchor: "top left",
                                                  self: "bottom right"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "webcast_status_info"
                                                      )
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c("q-btn-toggle", {
                                      attrs: {
                                        "toggle-color": _vm.getWebcastColorStatus(
                                          event.webcast
                                        ),
                                        options: _vm.webcast_statuses,
                                        disable: !_vm.permissions
                                          .presential_edit_events
                                      },
                                      model: {
                                        value: event.webcast.status,
                                        callback: function($$v) {
                                          _vm.$set(event.webcast, "status", $$v)
                                        },
                                        expression: "event.webcast.status"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "col-xs-12 col-sm-12 q-pa-xs" },
                              [
                                _c("strong", [
                                  !event.webcast.id
                                    ? _c(
                                        "p",
                                        { staticClass: "text-right q-pr-lg" },
                                        [
                                          _c("q-icon", {
                                            staticClass:
                                              "text-red q-pr-md q-pb-sm",
                                            staticStyle: {
                                              "font-size": "2rem"
                                            },
                                            attrs: {
                                              name:
                                                "fas fa-exclamation-triangle"
                                            }
                                          }),
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "event_has_not_yet_not_been_saved"
                                              )
                                            ) + "\n\t\t\t\t\t\t\t"
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    event.event_date_type === 3 && event.id !== 0
                      ? _c(
                          "div",
                          { staticClass: "q-mt-md row full-width" },
                          [
                            event.live_class.id && event.live_class.status === 5
                              ? _c(
                                  "q-card",
                                  {
                                    staticClass:
                                      "action-card q-my-sm q-px-sm q-py-md row"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "col-12 items-center" },
                                      [
                                        _c("q-btn", {
                                          staticClass: "self-center card-btn",
                                          attrs: {
                                            color: "secondary",
                                            label: _vm.$t("go_to_live_class"),
                                            icon: "fas fa-chalkboard-teacher"
                                          },
                                          on: {
                                            click: function($event) {
                                              event.live_class.platform_type ===
                                              "jitsi"
                                                ? (_vm.show_live_class_modal = true)
                                                : _vm.openMeeting(
                                                    event.live_class.embed
                                                  )
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              { staticClass: "col-xs-12 col-sm-12 q-mb-xs" },
                              [
                                _c(
                                  "q-field",
                                  {
                                    attrs: {
                                      count: 256,
                                      helper: _vm.$t(
                                        "leave_it_blank_to_use_the_training_title"
                                      )
                                    }
                                  },
                                  [
                                    _c("q-input", {
                                      ref: "title",
                                      refInFor: true,
                                      attrs: { "float-label": _vm.$t("title") },
                                      model: {
                                        value: event.live_class.title,
                                        callback: function($$v) {
                                          _vm.$set(
                                            event.live_class,
                                            "title",
                                            $$v
                                          )
                                        },
                                        expression: "event.live_class.title"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col-xs-12 col-sm-12" },
                              [
                                _c("q-select", {
                                  attrs: {
                                    helper: _vm.$t(
                                      "leave_it_blank_to_use_the_training_title"
                                    ),
                                    options: _vm.getLiveClassPlatformTypes,
                                    "float-label":
                                      event.live_class.platform_type === "jitsi"
                                        ? _vm.$t(
                                            "stream_type_jitsi_8x8_warning"
                                          )
                                        : _vm.$t("stream_type"),
                                    chips: "",
                                    "autofocus-filter": "",
                                    disable: !_vm.permissions
                                      .presential_edit_events
                                  },
                                  model: {
                                    value: event.live_class.platform_type,
                                    callback: function($$v) {
                                      _vm.$set(
                                        event.live_class,
                                        "platform_type",
                                        $$v
                                      )
                                    },
                                    expression: "event.live_class.platform_type"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col-xs-12 col-sm-12" },
                              [
                                event.live_class.platform_type !== "jitsi"
                                  ? _c("q-input", {
                                      attrs: {
                                        "float-label": _vm.$t(
                                          "transmission_url"
                                        ),
                                        error:
                                          _vm.$v.event_dates.$each[index].embed
                                            .$error,
                                        disable: !_vm.permissions
                                          .presential_edit_events
                                      },
                                      on: {
                                        input:
                                          _vm.$v.event_dates.$each[index].embed
                                            .$touch
                                      },
                                      model: {
                                        value: event.live_class.embed,
                                        callback: function($$v) {
                                          _vm.$set(
                                            event.live_class,
                                            "embed",
                                            $$v
                                          )
                                        },
                                        expression: "event.live_class.embed"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm.selected_client_params.live_class_use_score
                              ? _c(
                                  "div",
                                  { staticClass: "col-xs-12 col-sm-12" },
                                  [
                                    !_vm.selected_client_params
                                      .live_class_use_static_score &&
                                    _vm.canSetScoreLiveClass
                                      ? _c("q-input", {
                                          attrs: {
                                            "float-label": _vm.$t("score"),
                                            type: "number",
                                            disable:
                                              _vm.disableEvents ||
                                              !_vm.permissions
                                                .presential_edit_events
                                          },
                                          model: {
                                            value: event.live_class.score,
                                            callback: function($$v) {
                                              _vm.$set(
                                                event.live_class,
                                                "score",
                                                $$v
                                              )
                                            },
                                            expression: "event.live_class.score"
                                          }
                                        })
                                      : _vm._e(),
                                    _vm.selected_client_params
                                      .live_class_use_static_score &&
                                    _vm.canSetScoreLiveClass
                                      ? _c("q-select", {
                                          attrs: {
                                            options: _vm.scores,
                                            "float-label": _vm.$t("score"),
                                            disable:
                                              _vm.disableEvents ||
                                              !_vm.permissions
                                                .presential_edit_events
                                          },
                                          model: {
                                            value: event.live_class.score,
                                            callback: function($$v) {
                                              _vm.$set(
                                                event.live_class,
                                                "score",
                                                $$v
                                              )
                                            },
                                            expression: "event.live_class.score"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              { staticClass: "row gutter-sm q-mt-sm" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "col-xs-12 col-sm-12" },
                                  [
                                    _c(
                                      "p",
                                      { staticClass: "caption" },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t" +
                                            _vm._s(_vm.$t("status")) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        ),
                                        _c(
                                          "q-icon",
                                          {
                                            staticClass: "q-ml-sm q-pt-md",
                                            staticStyle: {
                                              "vertical-align": "bottom"
                                            },
                                            attrs: {
                                              name: "far fa-question-circle",
                                              size: "1.5rem",
                                              color: "grey"
                                            }
                                          },
                                          [
                                            _c(
                                              "q-tooltip",
                                              {
                                                staticClass: "custom-tooltip",
                                                attrs: {
                                                  anchor: "top left",
                                                  self: "bottom right"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "live_class_status_info"
                                                      )
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c("q-btn-toggle", {
                                      attrs: {
                                        "toggle-color": _vm.getLiveClassColorStatus(
                                          event.live_class
                                        ),
                                        options: _vm.live_class_statuses,
                                        disable: !_vm.permissions
                                          .presential_edit_events
                                      },
                                      model: {
                                        value: event.live_class.status,
                                        callback: function($$v) {
                                          _vm.$set(
                                            event.live_class,
                                            "status",
                                            $$v
                                          )
                                        },
                                        expression: "event.live_class.status"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "col-xs-12 col-sm-12 q-pa-xs" },
                              [
                                _c("strong", [
                                  !event.live_class.id
                                    ? _c(
                                        "p",
                                        { staticClass: "text-right q-pr-lg" },
                                        [
                                          _c("q-icon", {
                                            staticClass:
                                              "text-red q-pr-md q-pb-sm",
                                            staticStyle: {
                                              "font-size": "2rem"
                                            },
                                            attrs: {
                                              name:
                                                "fas fa-exclamation-triangle"
                                            }
                                          }),
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "event_has_not_yet_not_been_saved"
                                              )
                                            ) + "\n\t\t\t\t\t\t\t"
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ])
                              ]
                            ),
                            _vm.isSence
                              ? _c(
                                  "div",
                                  { staticClass: "row full-width q-mt-md" },
                                  [
                                    _c(
                                      "q-card",
                                      { staticStyle: { width: "100%" } },
                                      [
                                        _c(
                                          "q-card-title",
                                          {
                                            staticClass: "bg-blue text-white",
                                            staticStyle: { height: "60px" }
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.$t("sence_integration")
                                                ) +
                                                "\n\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        ),
                                        _c("q-card-main", [
                                          _c(
                                            "div",
                                            { staticClass: "row gutter-sm" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-xs-12 col-sm-6"
                                                },
                                                [
                                                  _c(
                                                    "q-field",
                                                    {
                                                      attrs: {
                                                        helper: _vm.$t(
                                                          "sence_code_hint"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("q-input", {
                                                        attrs: {
                                                          type: "text",
                                                          "float-label": _vm.$t(
                                                            "sence_code"
                                                          ),
                                                          error:
                                                            _vm.$v.event_dates
                                                              .$each[index]
                                                              .cod_sence.$error
                                                        },
                                                        on: {
                                                          input:
                                                            _vm.$v.event_dates
                                                              .$each[index]
                                                              .cod_sence.$touch
                                                        },
                                                        model: {
                                                          value:
                                                            event.cod_sence,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              event,
                                                              "cod_sence",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "event.cod_sence"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-xs-12 col-sm-6"
                                                },
                                                [
                                                  _c(
                                                    "q-field",
                                                    [
                                                      _c("q-input", {
                                                        attrs: {
                                                          type: "text",
                                                          "float-label": _vm.$t(
                                                            "sence_course"
                                                          ),
                                                          error:
                                                            _vm.$v.event_dates
                                                              .$each[index]
                                                              .cod_curso.$error
                                                        },
                                                        on: {
                                                          input:
                                                            _vm.$v.event_dates
                                                              .$each[index]
                                                              .cod_curso.$touch
                                                        },
                                                        model: {
                                                          value:
                                                            event.cod_curso,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              event,
                                                              "cod_curso",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "event.cod_curso"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.show_event_buttons
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "row gutter-sm full-width justify-end q-mt-xs",
                            class: _vm.$q.platform.is.mobile
                              ? "q-mx-md"
                              : "q-mr-md"
                          },
                          [
                            _vm.event_tab !== "new_event"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "col-xs-12 col-sm-3",
                                    class: _vm.getOrder("cancel")
                                  },
                                  [
                                    _c("q-btn", {
                                      staticClass: "full-width",
                                      attrs: {
                                        color: "negative",
                                        label: _vm.$t("remove_event"),
                                        icon: "fas fa-trash",
                                        disable: _vm.disableRemoveEvents
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.confirmRemoveEvent(
                                            _vm.event_dates[_vm.event_tab]
                                          )
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.showSave && _vm.event_tab !== "new_event"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "col-xs-12 col-sm-3",
                                    class: _vm.getOrder("save")
                                  },
                                  [
                                    _c("q-btn", {
                                      staticClass: "full-width",
                                      attrs: {
                                        color: "secondary",
                                        label: _vm.$t("save_event"),
                                        icon: "far fa-save"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.updateEvent(
                                            _vm.event_dates[_vm.event_tab]
                                          )
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.showSave && _vm.event_tab === "new_event"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "col-xs-12 col-sm-3",
                                    class: _vm.getOrder("save")
                                  },
                                  [
                                    _c("q-btn", {
                                      staticClass: "full-width",
                                      attrs: {
                                        color: "secondary",
                                        label: _vm.$t("save_event"),
                                        icon: "far fa-save"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.saveEvent()
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        )
                      : _vm._e(),
                    event.has_test === 3
                      ? _c(
                          "q-tabs",
                          {
                            staticClass: "full-width q-mt-md",
                            model: {
                              value: _vm.test_tab,
                              callback: function($$v) {
                                _vm.test_tab = $$v
                              },
                              expression: "test_tab"
                            }
                          },
                          [
                            _c("q-tab", {
                              attrs: {
                                slot: "title",
                                name: "tests",
                                label: _vm.$t("tests")
                              },
                              slot: "title"
                            }),
                            _c(
                              "q-tab-pane",
                              { attrs: { name: "tests" } },
                              [
                                _c("tests", {
                                  staticStyle: { padding: "0px" },
                                  attrs: {
                                    manage_models:
                                      _vm.permissions.manage_models,
                                    status: _vm.status,
                                    available_in: event.event_date,
                                    id_event: event.id,
                                    edit_tests: _vm.permissions.edit_tests
                                  },
                                  on: {
                                    toggleEventButtons: _vm.toggleEventButtons
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]
            )
          }),
          _vm.showAddEvents && _vm.permissions.presential_edit_events
            ? _c(
                "q-tab",
                {
                  attrs: {
                    slot: "title",
                    name: "new_event",
                    icon: "far fa-calendar-plus",
                    "aria-label": "new event"
                  },
                  slot: "title"
                },
                [
                  _c("q-tooltip", [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(_vm.$t("add_event_tooltip")) +
                        "\n\t\t\t"
                    )
                  ])
                ],
                1
              )
            : _vm._e(),
          _c("q-tab-pane", { attrs: { name: "new_event" } }, [
            _c("div", { staticClass: "row gutter-xs" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("q-select", {
                    attrs: {
                      options: _vm.event_date_types.map(function(e) {
                        return { label: _vm.$t(e.slug), value: e.value }
                      }),
                      error: _vm.$v.event_date_type.$error,
                      "float-label": _vm.$t("presential_event_type")
                    },
                    on: { input: _vm.$v.event_date_type.$touch },
                    model: {
                      value: _vm.event_date_type,
                      callback: function($$v) {
                        _vm.event_date_type = $$v
                      },
                      expression: "event_date_type"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-6 gutter" },
                [
                  _c("q-datetime", {
                    attrs: {
                      "float-label": _vm.$t("event_start"),
                      type: "datetime",
                      format: "DD/MM/YYYY HH:mm",
                      clearable: "",
                      error: _vm.$v.hr_start.$error
                    },
                    on: { input: _vm.$v.hr_start.$touch },
                    model: {
                      value: _vm.hr_start,
                      callback: function($$v) {
                        _vm.hr_start = $$v
                      },
                      expression: "hr_start"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-6 gutter" },
                [
                  _c("q-datetime", {
                    attrs: {
                      "float-label": _vm.$t("event_end"),
                      type: "datetime",
                      format: "DD/MM/YYYY HH:mm",
                      clearable: "",
                      error: _vm.$v.hr_end.$error
                    },
                    on: { input: _vm.$v.hr_end.$touch },
                    model: {
                      value: _vm.hr_end,
                      callback: function($$v) {
                        _vm.hr_end = $$v
                      },
                      expression: "hr_end"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("q-select", {
                    attrs: {
                      options: _vm.event_test_types,
                      error: _vm.$v.has_test.$error,
                      "float-label": _vm.$t("will_have_tests")
                    },
                    on: { input: _vm.$v.has_test.$touch },
                    model: {
                      value: _vm.has_test,
                      callback: function($$v) {
                        _vm.has_test = $$v
                      },
                      expression: "has_test"
                    }
                  })
                ],
                1
              ),
              _vm.has_test === 2
                ? _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-6" },
                    [
                      _c("q-input", {
                        attrs: {
                          type: "number",
                          error: _vm.$v.qty_questions.$error,
                          "float-label": _vm.$t("quantity_questions")
                        },
                        on: { input: _vm.$v.qty_questions.$touch },
                        model: {
                          value: _vm.qty_questions,
                          callback: function($$v) {
                            _vm.qty_questions = $$v
                          },
                          expression: "qty_questions"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.has_test === 2
                ? _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-6" },
                    [
                      _c("q-input", {
                        attrs: {
                          type: "number",
                          error: _vm.$v.minimum_score_approval.$error,
                          "float-label": _vm.$t("minimum_score")
                        },
                        on: { input: _vm.$v.minimum_score_approval.$touch },
                        model: {
                          value: _vm.minimum_score_approval,
                          callback: function($$v) {
                            _vm.minimum_score_approval = $$v
                          },
                          expression: "minimum_score_approval"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _vm.isSence && _vm.event_date_type === 3
              ? _c(
                  "div",
                  { staticClass: "row q-mt-lg" },
                  [
                    _c(
                      "q-card",
                      { staticStyle: { width: "100%" } },
                      [
                        _c(
                          "q-card-title",
                          {
                            staticClass: "bg-blue text-white",
                            staticStyle: { height: "60px" }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(_vm.$t("sence_integration")) +
                                "\n\t\t\t\t\t"
                            )
                          ]
                        ),
                        _c("q-card-main", [
                          _c("div", { staticClass: "row gutter-sm" }, [
                            _c(
                              "div",
                              { staticClass: "col-xs-12 col-sm-6" },
                              [
                                _c(
                                  "q-field",
                                  {
                                    attrs: { helper: _vm.$t("sence_code_hint") }
                                  },
                                  [
                                    _c("q-input", {
                                      attrs: {
                                        type: "text",
                                        "float-label": _vm.$t("sence_code"),
                                        error: _vm.$v.cod_sence.$error
                                      },
                                      on: { input: _vm.$v.cod_sence.$touch },
                                      model: {
                                        value: _vm.cod_sence,
                                        callback: function($$v) {
                                          _vm.cod_sence = $$v
                                        },
                                        expression: "cod_sence"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col-xs-12 col-sm-6" },
                              [
                                _c(
                                  "q-field",
                                  {
                                    attrs: {
                                      helper: _vm.$t("sence_course_hint")
                                    }
                                  },
                                  [
                                    _c("q-input", {
                                      attrs: {
                                        type: "text",
                                        "float-label": _vm.$t("sence_course"),
                                        error: _vm.$v.cod_curso.$error
                                      },
                                      on: { input: _vm.$v.cod_curso.$touch },
                                      model: {
                                        value: _vm.cod_curso,
                                        callback: function($$v) {
                                          _vm.cod_curso = $$v
                                        },
                                        expression: "cod_curso"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ])
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.show_event_buttons
              ? _c(
                  "div",
                  {
                    staticClass: "row gutter-sm full-width justify-end q-mt-lg",
                    class: _vm.$q.platform.is.mobile ? "q-mx-md" : "q-mr-md"
                  },
                  [
                    _vm.event_tab !== "new_event"
                      ? _c(
                          "div",
                          {
                            staticClass: "col-xs-12 col-sm-3",
                            class: _vm.getOrder("cancel")
                          },
                          [
                            _c("q-btn", {
                              staticClass: "full-width",
                              attrs: {
                                color: "negative",
                                label: _vm.$t("remove_event"),
                                icon: "fas fa-trash",
                                disable: _vm.disableRemoveEvents
                              },
                              on: {
                                click: function($event) {
                                  return _vm.confirmRemoveEvent(
                                    _vm.event_dates[_vm.event_tab]
                                  )
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.showSave && _vm.event_tab !== "new_event"
                      ? _c(
                          "div",
                          {
                            staticClass: "col-xs-12 col-sm-3",
                            class: _vm.getOrder("save")
                          },
                          [
                            _c("q-btn", {
                              staticClass: "full-width",
                              attrs: {
                                color: "secondary",
                                label: _vm.$t("save_event"),
                                icon: "far fa-save"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.updateEvent(
                                    _vm.event_dates[_vm.event_tab]
                                  )
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.showSave && _vm.event_tab === "new_event"
                      ? _c(
                          "div",
                          {
                            staticClass: "col-xs-12 col-sm-3",
                            class: _vm.getOrder("save")
                          },
                          [
                            _c("q-btn", {
                              staticClass: "full-width",
                              attrs: {
                                color: "secondary",
                                label:
                                  _vm.event_date_type !== 1
                                    ? _vm.$t("create_event")
                                    : _vm.$t("save_event"),
                                icon:
                                  _vm.event_date_type !== 1
                                    ? "far fa-calendar-plus"
                                    : "far fa-save"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.saveEvent()
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                )
              : _vm._e()
          ])
        ],
        2
      ),
      _c(
        "q-dialog",
        {
          on: { ok: _vm.removeEvent },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.confirm_remove_event = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("remove") },
                    on: {
                      click: function($event) {
                        return _vm.removeEvent()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_remove_event,
            callback: function($$v) {
              _vm.confirm_remove_event = $$v
            },
            expression: "confirm_remove_event"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("remove_event")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_remove_event")))
          ])
        ]
      ),
      _vm.show_webcast_modal
        ? _c(
            "q-modal",
            {
              attrs: {
                "content-css": { minWidth: "100vw", minHeight: "100vh" },
                "no-backdrop-dismiss": "",
                "no-esc-dismiss": "",
                maximized: ""
              },
              on: { hide: _vm.hideModal },
              model: {
                value: _vm.show_webcast_modal,
                callback: function($$v) {
                  _vm.show_webcast_modal = $$v
                },
                expression: "show_webcast_modal"
              }
            },
            [
              _c(
                "q-modal-layout",
                [
                  _c(
                    "q-toolbar",
                    { attrs: { slot: "header" }, slot: "header" },
                    [
                      _c("q-btn", {
                        attrs: {
                          flat: "",
                          round: "",
                          dense: "",
                          icon: "fas fa-times"
                        },
                        on: {
                          click: function($event) {
                            return _vm.hideModal()
                          }
                        }
                      }),
                      _c("q-toolbar-title", [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(
                              _vm.event_dates[_vm.event_tab].webcast.title
                            ) +
                            "\n\t\t\t\t"
                        )
                      ])
                    ],
                    1
                  ),
                  _vm.show_webcast_modal
                    ? _c("modal-webcast", {
                        attrs: {
                          webcast: _vm.event_dates[_vm.event_tab].webcast
                        },
                        on: { hideModal: _vm.hideModal }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.show_live_class_modal
        ? _c(
            "q-modal",
            {
              attrs: {
                "content-css": { minWidth: "100vw", minHeight: "100vh" },
                "no-backdrop-dismiss": "",
                "no-esc-dismiss": "",
                maximized: ""
              },
              on: { hide: _vm.hideModal },
              model: {
                value: _vm.show_live_class_modal,
                callback: function($$v) {
                  _vm.show_live_class_modal = $$v
                },
                expression: "show_live_class_modal"
              }
            },
            [
              _c(
                "q-modal-layout",
                [
                  _c(
                    "q-toolbar",
                    { attrs: { slot: "header" }, slot: "header" },
                    [
                      _c("q-btn", {
                        attrs: {
                          flat: "",
                          round: "",
                          dense: "",
                          icon: "fas fa-times"
                        },
                        on: {
                          click: function($event) {
                            return _vm.hideModal()
                          }
                        }
                      }),
                      _c("q-toolbar-title", [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(
                              _vm.event_dates[_vm.event_tab].live_class.title
                            ) +
                            "\n\t\t\t\t"
                        )
                      ])
                    ],
                    1
                  ),
                  _vm.show_live_class_modal
                    ? _c("modal-live-class", {
                        attrs: {
                          live_class: _vm.event_dates[_vm.event_tab].live_class,
                          date_class: _vm.event_dates[_vm.event_tab].hr_start,
                          id_presential: _vm.presential_event_id,
                          id_event: _vm.event_dates[_vm.event_tab].id
                        },
                        on: { hideModal: _vm.hideModal }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "q-dialog",
        {
          attrs: { "stack-buttons": "", "prevent-close": "" },
          on: {
            cancel: function($event) {
              _vm.show_meet_dialog = false
            },
            hide: function($event) {
              _vm.show_meet_dialog = false
            }
          },
          model: {
            value: _vm.show_meet_dialog,
            callback: function($$v) {
              _vm.show_meet_dialog = $$v
            },
            expression: "show_meet_dialog"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("window_blocked")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(_vm.$t("browser_window_blocked_click")) +
                "\n\t\t\t"
            ),
            _c(
              "a",
              {
                attrs: {
                  href:
                    _vm.event_dates[_vm.event_tab] &&
                    _vm.event_dates[_vm.event_tab].live_class &&
                    _vm.event_dates[_vm.event_tab].live_class.embed
                      ? _vm.event_dates[_vm.event_tab].live_class.embed
                      : null,
                  target: "_blank",
                  rel: "noopener noreferrer"
                }
              },
              [_vm._v(_vm._s(_vm.$t("here")))]
            ),
            _vm._v(
              "\n\t\t\t" + _vm._s(_vm.$t("to_access_the_class")) + "\n\t\t"
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }